<template>
<div class="chapter">
<div class="inner_page">
<h1 class="btnew"><a id="page_iii"></a>SECRET SERVICE GAINST THE NAZI REGIME</h1>
<p class="stit">HOW OUR SPIES DEALT WITH HITLER</p>
<p class="bkaut">EDWARD HARRISON</p>
<div class="img_container">
<img alt="images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?71df4fd0